/**
 * Re-export of the shared template renderer.
 *
 * `getNestedValue` is part of the binding contract that the theme builder and
 * this storefront must agree on, so it now lives in one place: the generated copy
 * in ../renderer, whose source is couponbase-builder/packages/template-renderer.
 *
 * The implementation moved; this module's public API did not, so the components
 * importing from here need no change.
 *
 * Edit the source in the builder repo and run `pnpm sync:renderer` there. A test
 * fails if ../renderer drifts from that source.
 */
export { getNestedValue, hasRenderableValue } from '../renderer';
